import { render, staticRenderFns } from "./Comissoes.vue?vue&type=template&id=33c0a710&scoped=true"
import script from "./Comissoes.vue?vue&type=script&lang=js"
export * from "./Comissoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c0a710",
  null
  
)

export default component.exports